import React, { Component } from 'react';
import { observer } from 'mobx-react';
import FiltersPanel from 'Components/DocumentHistory/filtersPanel';
import DocumentHistoryStore from 'Stores/DocumentHistory/documentHistoryStore';
import FiltersStore from 'Stores/DocumentHistory/FiltersStore';
import 'Styles/documentHistory.scss';
import HistoryLine from 'Components/DocumentHistory/historyLine';
import SmrTable from "Components/Common/SmrTable";
import { ShowModal, CloseModal } from 'Utils/CommonFunctions';
import { Navigate } from 'react-router-dom';
import Sorting from "Utils/Sorting";
import AppStore from 'Stores/AppStore';
import FiltersSimplePanel from "Components/Common/FiltersPanel/FiltersSimplePanel";

class DocumentHistory extends Component {
    componentDidMount() {
        AppStore.OnMainComponentMount('Выгрузка метаданных', 'documentHistory', this.ReloadData);

        this.ReloadData();
    }

    componentWillUnmount() {
        DocumentHistoryStore.ClearStore();
        FiltersStore.ClearStore();
    }

    ReloadData() {
        DocumentHistoryStore.ClearStore();
        FiltersStore.GetInitData();
        DocumentHistoryStore.GetData();
        CloseModal();
    }

    OnExportClicked(doc) {
        ShowModal({
            canBeClosed: true,
            header: `Экспорт ${AppStore.isMeeting ? "совещания" : "документа"} (${FiltersStore.filters.includeInitiative ? "Пользователь" : "Рег. №"}: ${doc.regNumOrUserName})`,
            children: `Экспортировать файлы ${AppStore.isMeeting ? "совещания" : "документа"} вместе с метаданными?`,
            buttons: [{
                content: "Нет",
                onClick: _ => DocumentHistoryStore.ExportTaskRun(doc, false),
                closer: true
            }, {
                content: "Да",
                onClick: _ => DocumentHistoryStore.ExportTaskRun(doc, true),
                closer: true
            }]
        });
    }

    renderTableLine(item) {
        return <HistoryLine item={item}
            OnExportClicked={this.OnExportClicked.bind(this)}
            key={`history-line-${item.id}`} />
    }

    cleanTableData() {
        DocumentHistoryStore.tableStore.CleanStore();
    }

    renderHeader() {
        return (
            <div className='document-history-table-header'>
                <div className="table-column-content-sortable" onClick={() => this.SetSortOrderNext("RegNumOrUserName")}>
                    {FiltersStore.filters.includeInitiative ? "Пользователь" : "Рег. №"} {this.GetSortOrderIcon("RegNumOrUserName")}
                </div>
                <div className="table-column-content-sortable" onClick={() => this.SetSortOrderNext("RegDateOrLastModifyDate")}>
                    {FiltersStore.filters.includeInitiative ? "Дата изменения" : "Дата регистрации"} {this.GetSortOrderIcon("RegDateOrLastModifyDate")}
                </div>
                <div>
                    Выгрузка
                </div>
            </div>
        );
    }

    GetSortOrderIcon(fieldName) {
        return Sorting.GetSortOrderIconParamValuesSort(FiltersStore.filters.sortRules, fieldName);
    }

    SetSortOrderNext(fieldName) {
        FiltersStore.filters.sortRules = Sorting.SetSortOrderNext(FiltersStore.filters.sortRules, fieldName);
        DocumentHistoryStore.GetData();
    }

    render() {
        if (this.props.migrationInProcess) {
            return (
                <Navigate to={`${window.SmrLocation}/migration`} />
            )
        }

        return (
            <div className='document-history-container'>
                <FiltersSimplePanel
                    className={(FiltersStore.initDataLoading ? ' disabled' : '')}
                    getFiltersRender={() => FiltersStore.filtersRender}
                    getFilters={() => FiltersStore.filters}
                    clearFilters={() => {
                        FiltersStore.ClearFiltersRender();
                        FiltersStore.SaveFiltersFromRender();
                        DocumentHistoryStore.GetData(1);
                    }}
                    visibleFiltersFieldNames={["regNumAlias", "matchWholeWord"]}
                    disabledFiltersFieldNames={FiltersStore.filters.includeInitiative ? ["regNumAlias", "matchWholeWord"] : null}
                    search={() => DocumentHistoryStore.GetData(1)}
                    getSelectedFiltersCount={() => FiltersStore.GetSelectedFiltersCount()}
                    showFullFilters={() => {
                        ShowModal({
                            className: "filters-modal",
                            canBeClosed: true,
                            blockProductSwitcher: true,
                            header: 'Фильтрация данных',
                            children: (<FiltersPanel />),
                            buttons:
                                [
                                    {
                                        content: 'Очистить',
                                        closer: false,
                                        onClick: _ => FiltersStore.ClearFiltersRender()
                                    }, {
                                        content: 'Применить',
                                        closer: true,
                                        className: "blue-button",
                                        onClick: _ => {
                                            FiltersStore.SaveFiltersFromRender();
                                            DocumentHistoryStore.GetData(1);
                                        }
                                    }
                                ],
                            width: '480px',
                            height: "90%"
                        });
                    }}
                />
                <SmrTable
                    loading={DocumentHistoryStore.recordsLoading}
                    renderTableLine={this.renderTableLine.bind(this)}
                    cleanTableData={this.cleanTableData.bind(this)}
                    renderHeader={this.renderHeader.bind(this)}
                    getDataPage={DocumentHistoryStore.GetData.bind(DocumentHistoryStore)}
                    location={this.props.location}
                    setTableStore={DocumentHistoryStore.SetTableStore.bind(DocumentHistoryStore)}
                />
            </div>
        )
    }
}

export default observer(DocumentHistory);